import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ROUTER_TOKENS } from '../../../../../../../apps/promo-web/web-toyo/src/app/app.routes';
import { IImageGallery } from '@web-nx-ng-tsc/web-shared-data-access';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-gallery-card',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './lib-gallery-card.component.html',
  styleUrl: './lib-gallery-card.component.scss',
})
export class LibGalleryCardComponent {
  @Input() set data(value: IImageGallery) {
    this.dataSignal.set(value);
  }

  @Input() set pathName(value: string) {
    this.pathNameSignal.set(value);
  }

  @Input() headingLevel: 'h2' | 'h3' = 'h2';
  @Output() emitNewsUrl = new EventEmitter();

  protected readonly ROUTER_TOKENS = ROUTER_TOKENS;
  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<IImageGallery>({
    img: '',
    name: '',
    description: '',
    hot_badge_enable: 1,
    id: 0,
  });

  pathNameSignal = signal<string>(this.ROUTER_TOKENS.GALLERY);
  // Method to get the first image URL from comma-separated URLs
  getFirstImageUrl(): string {
    const img = this.dataSignal().img;
    if (!img) return '';

    // Split by comma and get the first URL, then trim whitespace
    return img.split(',')[0]?.trim() || '';
  }
}
